import { ListOfServiceProviders } from "./ServiceProviders.types";

import { IMessageBar } from "@/core/libs/message-bar";

export enum ServiceProvidersActionsTypes {
  CREATE_REQUEST = "serviceProviders/CREATE_REQUEST",
  CREATE_FAIL = "serviceProviders/CREATE_FAIL",
  CREATE_SUCCESS = "serviceProviders/CREATE_SUCCESS",
  DISMISS_MESSAGE = "serviceProviders/DISMISS_MESSAGE",
  EDIT_REQUEST = "serviceProviders/EDIT_REQUEST",
  EDIT_FAIL = "serviceProviders/EDIT_FAIL",
  EDIT_SUCCESS = "serviceProviders/EDIT_SUCCESS",
  LIST_REQUEST = "serviceProviders/LIST_REQUEST",
  LIST_FAIL = "serviceProviders/LIST_FAIL",
  LIST_SUCCESS = "serviceProviders/LIST_SUCCESS"
}

export interface ServiceProvidersState {
  isLoadingList: boolean;
  list: ListOfServiceProviders;
  message?: IMessageBar;
}

interface CreateRequest {
  type: ServiceProvidersActionsTypes.CREATE_REQUEST;
}

interface CreateError {
  type: ServiceProvidersActionsTypes.CREATE_FAIL;
  payload: {
    message: IMessageBar;
  };
}

interface CreateSuccess {
  type: ServiceProvidersActionsTypes.CREATE_SUCCESS;
  payload: {
    message: IMessageBar;
  };
}

interface DismissMessage {
  type: ServiceProvidersActionsTypes.DISMISS_MESSAGE;
}

interface EditRequest {
  type: ServiceProvidersActionsTypes.EDIT_REQUEST;
}

interface EditError {
  type: ServiceProvidersActionsTypes.EDIT_FAIL;
  payload: {
    message: IMessageBar;
  };
}

interface EditSuccess {
  type: ServiceProvidersActionsTypes.EDIT_SUCCESS;
  payload: {
    message: IMessageBar;
  };
}

interface ListRequest {
  type: ServiceProvidersActionsTypes.LIST_REQUEST;
}

interface ListError {
  type: ServiceProvidersActionsTypes.LIST_FAIL;
}

interface ListSuccess {
  type: ServiceProvidersActionsTypes.LIST_SUCCESS;
  payload: {
    list: ListOfServiceProviders;
  };
}

export type ServiceProvidersReducerActions =
  | CreateRequest
  | CreateError
  | CreateSuccess
  | DismissMessage
  | EditRequest
  | EditError
  | EditSuccess
  | ListRequest
  | ListError
  | ListSuccess;
